async function fetchProducts(collectionId, limit) {
  const storefrontAccessToken = '78ebf120a58e4c9e5dc780f26d63df56'; // Replace this with your actual Storefront API access token
  const query = `
    {
      collection(id: "gid://shopify/Collection/${collectionId}") {
        products(first: ${limit}) {
          edges {
            node {
              id
              title
              handle
              images(first: 1) {
                edges {
                  node {
                    src
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({ query: query }),
  };

  const response = await fetch('/api/2023-01/graphql.json', requestOptions);
  const data = await response.json();

  const products = data.data.collection.products.edges.map(edge => edge.node);
  return products;
}


function displayProducts(products, targetGrid) {
  targetGrid.innerHTML = ''; // Clear the existing content in the target grid

  products.forEach((product) => {
    const productLink = document.createElement('a');
    productLink.href = `/products/${product.handle}`;
    productLink.classList.add('product-link');

    const productCard = document.createElement('div');
    productCard.classList.add('product-card');

    const productTitle = document.createElement('h3');
    productTitle.textContent = product.title;

    const productImage = document.createElement('img');

    // Check if the product has an image before accessing 'src'
    if (product.images.edges[0]) {
      productImage.src = product.images.edges[0].node.src;
    } else {
      productImage.src = 'https://via.placeholder.com/150'; // Use a placeholder image if the product doesn't have an image
    }

    productImage.alt = product.title;

    productCard.appendChild(productImage);
    productCard.appendChild(productTitle);

    productLink.appendChild(productCard);
    targetGrid.appendChild(productLink);
  });
}


// Other functions (fetchProducts and displayProducts) should remain unchanged

document.addEventListener('DOMContentLoaded', async function() {
    console.log('DOM content loaded');

    // Get the search button element
    const searchButton = document.getElementById('search-button');
    console.log('searchButton', searchButton);

    // Get the Exclusive Artwork and Signature Artwork div elements
    const exclusiveArtworkGrid = document.getElementById('exclusive-artwork-grid');
    const signatureArtworkGrid = document.getElementById('signature-artwork-grid');

    // Add a click event listener to the search button
    searchButton.addEventListener('click', async function(event) {
        console.log('Search button clicked');

        // Display the "Search is working" message in both containers
        exclusiveArtworkGrid.innerHTML = '<p>Search is working...</p>';
        signatureArtworkGrid.innerHTML = '<p>Search is working...</p>';

        const exclusiveCollectionId = '282094764224';
        const signatureCollectionId = '232898298048';
        const limit = 10;

        const exclusiveProducts = await fetchProducts(exclusiveCollectionId, limit);
        const signatureProducts = await fetchProducts(signatureCollectionId, limit);

        console.log('Exclusive Products:', exclusiveProducts);
        console.log('Signature Products:', signatureProducts);

        displayProducts(exclusiveProducts, exclusiveArtworkGrid);
        displayProducts(signatureProducts, signatureArtworkGrid);
    });
});

